import React, { useState, useEffect } from 'react';
import Logo from '../../Images/dsmlogoblack.png';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { useDispatch, useSelector } from 'react-redux';
import { FiArrowRight, FiHeadphones } from 'react-icons/fi';
import { login } from '../../Redux/Auth/authActions';
import LoadingScreen from '../../ReusableBlocks/LoadingScreen';
import { useFeatureFlags } from '../../FeatureFlags/FeatureFlagsContext';
import { FEATURE_FLAGS } from '../../FeatureFlags/featureFlagConstants';

const SHOW_FLOATING_DEMO_SUPPORT = false;
const SHOW_CARD_DEMO_SUPPORT = true;


const Login = () => {



  const [email, setEmail] = useState('');
  const [pin, setPin] = useState('');
  const dispatch = useDispatch();
  const isLoading = useSelector(state => state.auth.isLoading);
  const isAuthenticated = useSelector(state => state.auth.isAuthenticated);
  const currentUser = useSelector(state => state.auth?.currentUser);
  const errorMessage = useSelector(state => state.auth.errorMessage);

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const navigate = useNavigate();
  const { isFeatureEnabled } = useFeatureFlags();
  const showForgotPassword = isFeatureEnabled(FEATURE_FLAGS.EnableForgetPassword);
  const showAccountRequest = isFeatureEnabled(FEATURE_FLAGS.EnableAccountRequest);
  const showSalesDemo = isFeatureEnabled(FEATURE_FLAGS.EnableSalesDemo);
  const showSupport = isFeatureEnabled(FEATURE_FLAGS.EnableSupport);




  // useEffect(() => {
  //   if (isAuthenticated) {
  //     navigate('/home');
  //   }
  // }, [isAuthenticated, navigate]);


  useEffect(() => {
    if (isAuthenticated) {
      if (
        currentUser?.typeOfUser === "Sales"
        && showSalesDemo
        && !currentUser.salesDemoTutorialCompletion
      ) {
        navigate("/onboarding");
        return;
      }
      navigate("/home");
    }
  }, [isAuthenticated, navigate, currentUser, showSalesDemo]);



  useEffect(() => {
    if (errorMessage) {
      Swal.fire({
        title: 'Error',
        text: errorMessage,
        icon: 'error',
        confirmButtonText: 'Retry',
        customClass: {
          title: 'my-custom-title-of-pop-login',
          confirmButton: 'my-custom-button-of-pop',
        },
      });
    }
  }, [errorMessage]);



  const handleEmailChange = (e) => setEmail(e.target.value);
  const handlePinChange = (e) => setPin(e.target.value);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (email.trim() === '' || pin.trim() === '') {
      Swal.fire({
        title: 'Please enter email and password',
        confirmButtonText: 'Retry',
        customClass: {
          title: 'my-custom-title-of-pop-login',
          confirmButton: 'my-custom-button-of-pop',
        },
      });
      return;
    }

    if (!emailRegex.test(email)) {
      Swal.fire({
        title: 'This email is not Registered',
        confirmButtonText: 'Retry',
        customClass: {
          title: 'my-custom-title-of-pop-login',
          confirmButton: 'my-custom-button-of-pop',
        },
      });
      return;
    }

    // Dispatch login action
    dispatch(login(email, pin));
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSubmit(e); // Pass the event object here
    }
  };



  const handleResetPasswordClick = () => {
    navigate('/forgot-password');
  };


  const handleRequestAccountClick = () => {
    navigate('/create-account');
    // window.location.href = `mailto:_61ec6@bmc.com?subject=Account Request&body=Hello,%0D%0A%0D%0AI would like to request an account for DSOM Tech Central. Please assist me with the account creation process.%0D%0A%0D%0AMy email address is: ${email}%0D%0A%0D%0AThank you,%0D%0A[Your Name]`;
  };

  const handleSupportClick = () => {
    navigate('/support', {
      state: { source: 'login' },
    });
  };

  return (
    <>
      {isLoading && <LoadingScreen />}
      <section className='login-section-bg'>
        <div className='login-page-content'>
          <div className='login-section'>
            <div className='login-section-inner'>
              <img className='login-logo' src={Logo} alt='Demo Central Logo' width='250' />
              <div className='log-sec-2'>
                <h3 className='log-sec-sign-in'>Sign In</h3>
                <p className='log-sec-sign-in-sub'>
                  Enter your mail and password for demo central
                </p>
                <input
                  className='input-box-username'
                  type='email'
                  placeholder='Username'
                  value={email}
                  onChange={handleEmailChange}
                  onKeyDown={handleKeyDown}
                  required
                />
                <br />
                <input
                  className='input-box-pin'
                  type='password'
                  value={pin}
                  placeholder='Password'
                  onChange={handlePinChange}
                  onKeyDown={handleKeyDown}
                  required
                />
                <br />
                <button type='submit' className='login-btn' onClick={handleSubmit}>
                  Sign In
                </button>
                {showForgotPassword && (
                  <p className='reset-pass' onClick={handleResetPasswordClick}>Forgot Password?</p>
                )}
              </div>
              {showAccountRequest && (
                <div className='login-sec-bottom-sect'>
                  <h5 className='login-sec-bot-dont'>Don't Have Account?</h5>
                  <p className='login-sec-bot-req' onClick={handleRequestAccountClick}>Request for account</p>
                </div>
              )}
              {showSupport && SHOW_CARD_DEMO_SUPPORT && (
                <button
                  type='button'
                  className='login-demo-support'
                  onClick={handleSupportClick}
                  aria-label='Submit a support ticket'
                >
                  <span className='login-demo-support__label'>
                    Having an issue?
                  </span>

                  <span className='login-demo-support__action'>
                    Submit a ticket
                  </span>
                </button>
              )}
            </div>
          </div>
        </div>

        {showSupport && SHOW_FLOATING_DEMO_SUPPORT && (
          <button
            type='button'
            className='login-support-pill'
            onClick={handleSupportClick}
            aria-label='Submit a demo support ticket'
          >
            <span className='login-support-pill__icon' aria-hidden='true'>
              <FiHeadphones />
            </span>
            <span className='login-support-pill__content'>
              <span className='login-support-pill__title'>Need help with a demo?</span>
              <span className='login-support-pill__action'>
                Submit a ticket
                <FiArrowRight aria-hidden='true' />
              </span>
            </span>
          </button>
        )}
      </section>
    </>
  );
};

export default Login;
